var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _path8, _g7, _g8, _g9, _path9, _path10, _path11, _path12, _path13, _path14, _g10, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumandriven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 242,
    viewBox: "0 0 185 242",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.874 233.526L172.795 204.704C188.233 195.792 188.233 173.508 172.795 164.592L122.874 135.77C103.886 124.805 80.4874 124.805 61.4995 135.77L11.5784 164.592C-3.85948 173.504 -3.85948 195.788 11.5784 204.704L61.4995 233.526C80.4874 244.491 103.886 244.491 122.874 233.526Z",
    fill: "url(#paint0_radial_391_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.205 227.799L163.293 202.92C177.358 194.8 177.358 174.496 163.293 166.375L120.205 141.497C102.865 131.486 81.504 131.486 64.164 141.497L21.0765 166.375C7.01182 174.496 7.01182 194.8 21.0765 202.92L64.164 227.799C81.504 237.809 102.865 237.809 120.205 227.799Z",
    fill: "url(#paint1_radial_391_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.235 221.635L153.489 200.704C166.184 193.375 166.184 175.055 153.489 167.726L117.235 146.795C101.547 137.735 82.2187 137.735 66.5307 146.795L30.2766 167.726C17.5811 175.055 17.5811 193.375 30.2766 200.704L66.5307 221.635C82.2187 230.695 101.547 230.695 117.235 221.635Z",
    fill: "url(#paint2_radial_391_7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.868 216.341L144.293 199.354C155.615 192.82 155.615 176.476 144.293 169.942L114.868 152.954C100.832 144.85 83.5373 144.85 69.4972 152.954L40.0726 169.942C28.7503 176.476 28.7503 192.82 40.0726 199.354L69.4972 216.341C83.5332 224.446 100.828 224.446 114.868 216.341Z",
    fill: "url(#paint3_radial_391_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.204 210.615L134.795 197.571C144.744 191.828 144.744 177.468 134.795 171.725L112.204 158.681C99.8155 151.528 84.558 151.528 72.17 158.681L49.5788 171.725C39.6298 177.468 39.6298 191.828 49.5788 197.571L72.17 210.615C84.558 217.768 99.8155 217.768 112.204 210.615Z",
    fill: "url(#paint4_radial_391_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.535 204.888L125.293 195.792C133.868 190.84 133.868 178.464 125.293 173.512L109.535 164.416C98.7989 158.218 85.5747 158.218 74.8386 164.416L59.081 173.512C50.5053 178.464 50.5053 190.84 59.081 195.792L74.8386 204.888C85.5747 211.087 98.7989 211.087 109.535 204.888Z",
    fill: "url(#paint5_radial_391_7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.866 199.158L115.79 194.005C122.993 189.844 122.993 179.448 115.79 175.292L106.866 170.139C97.7823 164.896 86.5872 164.896 77.5032 170.139L68.579 175.292C61.3766 179.452 61.3766 189.848 68.579 194.005L77.5032 199.158C86.5872 204.401 97.7823 204.401 106.866 199.158Z",
    fill: "url(#paint6_radial_391_7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 126.535L142.653 97.397L92.1868 68.2593L41.7205 97.397L92.1868 126.535Z",
    fill: "url(#paint7_linear_391_7)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 184.806L142.653 155.668V97.397L92.1868 126.535V184.806Z",
    fill: "url(#paint8_linear_391_7)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 184.806L41.7205 155.668V97.397L92.1868 126.535V184.806Z",
    fill: "url(#paint9_linear_391_7)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_df_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3762 120.697L50.0461 104.341C49.1606 103.828 48.8573 102.701 49.3697 101.816C49.8822 100.93 51.0094 100.627 51.8949 101.139L80.225 117.495C81.1105 118.008 81.4138 119.135 80.9014 120.021C80.389 120.906 79.2617 121.209 78.3762 120.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.338 141.406V174.123C90.338 175.144 91.166 175.972 92.1868 175.972C93.2075 175.972 94.0356 175.144 94.0356 174.123V141.406C94.0356 140.386 93.2075 139.558 92.1868 139.558C91.166 139.558 90.338 140.386 90.338 141.406Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_df_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.993 120.697L134.323 104.341C135.209 103.828 135.512 102.701 135 101.816C134.487 100.93 133.36 100.627 132.475 101.139L104.144 117.495C103.259 118.008 102.956 119.135 103.468 120.021C103.98 120.906 105.108 121.209 105.993 120.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7078 110.203L117.16 97.241C118.275 96.5974 118.275 94.9863 117.16 94.3428L96.6632 82.5081C93.8962 80.9094 90.4814 80.9094 87.7144 82.5081L67.7017 94.064C66.3695 94.8306 66.3695 96.7531 67.7017 97.5197L89.6698 110.203C91.2316 111.105 93.1542 111.105 94.7119 110.203H94.7078Z",
    fill: "#143247"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M51.2759 11.2419L63.3237 90.4237C63.4057 90.8869 63.5328 91.5879 63.6681 92.0347C64.4879 94.7443 66.2219 97.126 68.706 98.5853L88.0628 109.953C88.0997 109.973 88.6327 110.285 88.6696 110.301C90.5184 111.199 92.773 111.191 94.6176 110.277L116.209 97.5933C117.938 96.6095 119.025 95.0805 119.472 93.2317C119.488 93.162 119.718 91.7518 119.718 91.6576L130.675 11.2378C130.675 10.5573 117.237 10.0039 116.557 10.0039H65.4102C64.7298 10.0039 51.2759 10.5573 51.2759 11.2378V11.2419Z",
    fill: "url(#paint10_linear_391_7)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M53.8502 12.476L63.4877 90.3747C63.5532 90.7477 63.6639 91.6004 63.7623 91.9611C64.5002 94.6379 66.0825 97.0442 68.5257 98.479L88.0588 109.953C88.1285 109.994 88.5999 110.269 88.6777 110.301C90.5552 111.191 92.8139 111.174 94.6832 110.248L115.975 97.737C117.758 96.7491 118.914 95.3963 119.369 93.5885C119.406 93.445 119.607 92.2234 119.607 92.0308L128.371 12.4678C128.371 11.1027 116.959 10 115.594 10H66.6441C65.279 10 53.8543 11.1068 53.8543 12.4678L53.8502 12.476Z",
    fill: "url(#paint11_linear_391_7)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.4205 13.7097L63.6475 90.3253C63.6967 90.604 63.7869 91.6166 63.8566 91.8871C64.5125 94.5312 65.9431 96.962 68.3412 98.3722L88.0465 109.953C88.1531 110.014 88.5589 110.252 88.6737 110.301C90.5799 111.187 92.8426 111.162 94.7324 110.223L115.721 97.8844C117.561 96.8964 118.779 95.7158 119.246 93.9531C119.304 93.74 119.472 92.7029 119.472 92.4118L126.047 13.7097C126.047 11.6641 116.659 10.0039 114.614 10.0039H67.8657C65.8202 10.0039 56.4205 11.6641 56.4205 13.7097Z",
    fill: "url(#paint12_linear_391_7)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M58.9949 14.9435L63.8156 90.2761C63.8484 90.4606 63.914 91.633 63.955 91.8133C64.5289 94.4328 65.812 96.8842 68.1609 98.2656L88.0383 109.953C88.1818 110.035 88.5261 110.236 88.6777 110.301C90.6126 111.178 92.8836 111.146 94.7939 110.195L115.479 98.0278C117.373 97.0358 118.66 96.0315 119.135 94.3098C119.213 94.0269 119.353 93.1702 119.353 92.7849L123.735 14.9435C123.735 12.2175 116.368 10.0039 113.642 10.0039H69.0955C66.3695 10.0039 58.9949 12.2134 58.9949 14.9435Z",
    fill: "url(#paint13_linear_391_7)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M61.5651 16.1818L63.9755 90.2313C63.9919 90.3256 64.0288 91.6537 64.0452 91.7439C64.5412 94.347 65.6685 96.8066 67.9723 98.1634L88.026 109.957C88.2022 110.064 88.4851 110.219 88.6737 110.306C90.6372 111.179 92.9123 111.134 94.8472 110.174L115.233 98.1798C117.18 97.1878 118.533 96.3556 119.021 94.6749C119.123 94.3224 119.226 93.6501 119.226 93.1664L121.419 16.1818C121.419 12.7712 116.077 10.0083 112.667 10.0083H70.3171C66.9065 10.0083 61.5651 12.7712 61.5651 16.1818Z",
    fill: "url(#paint14_linear_391_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 17.4157V91.666C63.8484 94.2896 65.2381 96.7205 67.5009 98.0527L87.7267 109.953C87.9399 110.08 88.1572 110.199 88.3868 110.297C90.379 111.162 92.6582 111.113 94.6177 110.142L114.7 98.3192C117.221 97.0689 118.816 96.3556 118.816 93.5394V17.4157C118.816 13.3246 115.499 10.0083 111.408 10.0083H71.2599C67.1688 10.0083 63.8525 13.3246 63.8525 17.4157H63.8484Z",
    fill: "url(#paint15_linear_391_7)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.52 31.7016C126.52 29.1389 125.171 26.9808 123.013 25.632C124.092 24.4181 124.631 22.7995 124.631 21.0461C124.631 17.674 122.203 14.8415 119.101 14.1671C119.641 12.2788 119.641 10.1207 116.943 7.42308C115.594 6.07427 113.706 5.1301 111.817 5.26498C110.738 5.39986 109.659 5.66963 108.715 6.20915C108.311 2.70224 105.343 -0.130255 101.701 0.00462549C97.7899 0.00462549 94.6876 3.10689 94.6876 7.01844V7.15332C94.6876 7.2882 94.6876 7.2882 94.6876 7.42308L94.9574 49.1013C94.9574 49.5059 94.9574 49.9106 95.0922 50.1803C95.0922 50.4501 94.9574 50.7199 94.9574 50.9896C94.9574 54.9012 98.0596 58.0034 101.971 58.0034C103.86 58.0034 105.748 57.1941 106.962 55.8453C107.636 55.9802 108.311 56.1151 108.985 56.1151C112.897 56.1151 115.999 53.0128 115.999 49.1013C119.91 49.1013 123.013 45.999 123.013 42.0875C123.013 40.6038 122.608 39.255 121.799 38.1759C124.631 37.3666 126.654 34.8039 126.52 31.7016Z",
    fill: "url(#paint16_linear_391_7)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 31.8363C58 29.2736 59.3488 26.9806 61.5069 25.7667C60.4279 24.5527 59.7535 22.9342 59.7535 21.1807C59.7535 17.8087 62.1813 14.9762 65.2836 14.3018C64.7441 12.4134 64.7441 10.2553 67.3068 7.55773C68.6556 6.20892 70.5439 5.26475 72.4323 5.39963C73.5113 5.53451 74.5904 5.80428 75.5345 6.3438C75.9392 2.8369 78.9066 0.00439453 82.5483 0.00439453C86.4599 0.00439453 89.5622 3.10666 89.5622 7.0182V7.15308C89.5622 7.28797 89.5622 7.28797 89.5622 7.42285V48.9662C89.5622 49.3708 89.5622 49.7755 89.4273 50.0452C89.4273 50.315 89.5622 50.5847 89.5622 50.8545C89.5622 54.7661 86.4599 57.8683 82.5483 57.8683C80.66 57.8683 78.7717 57.059 77.5578 55.8451C76.8833 55.98 76.2089 56.1149 75.5345 56.1149C71.623 56.1149 68.5207 53.0126 68.5207 49.1011C64.6092 49.1011 61.5069 45.9988 61.5069 42.0872C61.5069 40.6036 61.9116 39.2547 62.7208 38.1757C59.8883 37.3664 58 34.8037 58 31.8363Z",
    fill: "url(#paint17_linear_391_7)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9574 19.5622C98.734 19.5622 104.264 18.8878 106.152 11.3345",
    stroke: "#153354",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.008 26.307C111.008 26.307 102.376 26.307 101.027 17.9443",
    stroke: "#153354",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2974 41.9523C76.0741 41.9523 81.6042 41.2779 83.4925 33.7246",
    stroke: "#153354",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5622 47.4827C89.5622 47.4827 80.9298 47.4827 79.581 39.1201",
    stroke: "#153354",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.59 43.571L104.534 46.1337C108.311 44.65 113.436 45.4593 116.134 49.3709C117.078 49.3709 118.022 49.1011 118.966 48.8313C115.594 42.8966 108.58 41.5478 103.59 43.571Z",
    fill: "#153354"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.269 36.6925C116.269 36.6925 110.604 36.5577 111.413 44.111",
    stroke: "#153354",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_391_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2836 14.4369C64.3394 14.7067 63.3952 15.1113 62.586 15.6508C64.2045 17.1345 66.9022 19.0229 70.2742 19.2926C70.5439 19.2926 70.8137 19.2926 71.0835 19.2926C74.5904 19.2926 78.2322 17.5392 81.7391 14.1671L79.8507 12.2788C76.6136 15.3811 73.3764 16.8648 70.4091 16.595C68.3858 16.3252 66.4975 15.2462 65.2836 14.4369C65.2836 14.302 65.2836 14.302 65.2836 14.4369Z",
    fill: "url(#paint18_linear_391_7)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9254 29.4085C68.9254 29.4085 75.9392 26.9807 73.7811 18.7529",
    stroke: "#122E51",
    strokeWidth: 2.69762,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_391_7",
    x: 41.7205,
    y: 68.2593,
    width: 100.933,
    height: 62.2754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_391_7",
    x: 92.1868,
    y: 97.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_391_7",
    x: 41.7205,
    y: 97.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_391_7",
    x: 44.1206,
    y: 95.8901,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_391_7",
    x: 85.338,
    y: 134.558,
    width: 13.6976,
    height: 49.4141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_df_391_7",
    x: 98.2189,
    y: 95.8901,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_7",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_391_7",
    x: 94.6876,
    y: 0,
    width: 31.8383,
    height: 62.0034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_391_7",
    x: 58,
    y: 0.00439453,
    width: 31.5621,
    height: 61.8638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_391_7",
    x: 62.586,
    y: 12.2788,
    width: 19.1531,
    height: 11.0137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.446 186.624) rotate(-166.554) scale(91.8208 44.9448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.5007 186.401) rotate(-166.533) scale(81.3394 39.8701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.2554 185.745) rotate(-166.508) scale(70.859 34.7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.6123 185.955) rotate(-166.473) scale(60.3816 29.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6727 185.732) rotate(-166.421) scale(49.8987 24.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.7291 185.514) rotate(-166.345) scale(39.4152 19.5695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_391_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7836 185.286) rotate(-166.213) scale(28.9341 14.4944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_391_7",
    x1: 145.596,
    y1: 109.301,
    x2: 117.426,
    y2: 52.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_391_7",
    x1: 144.125,
    y1: 158.956,
    x2: 95.2366,
    y2: 126.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_391_7",
    x1: 93.6584,
    y1: 158.956,
    x2: 44.7703,
    y2: 126.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_391_7",
    x1: 90.9754,
    y1: 10.0039,
    x2: 90.9754,
    y2: 110.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_391_7",
    x1: 91.1107,
    y1: 10,
    x2: 91.1107,
    y2: 110.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_391_7",
    x1: 91.2337,
    y1: 10.0039,
    x2: 91.2337,
    y2: 110.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_391_7",
    x1: 91.3648,
    y1: 10.0039,
    x2: 91.3648,
    y2: 110.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_391_7",
    x1: 91.4919,
    y1: 10.0083,
    x2: 91.4919,
    y2: 110.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_391_7",
    x1: 91.3321,
    y1: 10.0083,
    x2: 91.3321,
    y2: 110.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_391_7",
    x1: 127.454,
    y1: 40.8497,
    x2: 95.6678,
    y2: 20.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_391_7",
    x1: 90.4825,
    y1: 40.7558,
    x2: 58.8577,
    y2: 20.7816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_391_7",
    x1: 82.2976,
    y1: 17.2184,
    x2: 79.8566,
    y2: 9.49998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumandriven);
export default __webpack_public_path__ + "static/media/humandriven.0ccb726b12c5b5905114f0ae59d67e69.svg";
export { ForwardRef as ReactComponent };